// @ts-check
import axiosAPI from "@/axios-auth";
import type { eventFilterType, eventType } from "@/components/statics/types";
import { print } from "graphql";
import { defineStore } from "pinia";
import { ref } from "vue";
import { queryEvents } from "./schema/query";

export const useEventListStore = defineStore("eventListStore", () => {
  //==state
  const eventList = ref<eventType[]>();
  //==action
  const getEventList = (
    filter: eventFilterType,
    needHaspga: boolean = false
  ) => {
    // let variables = {};

    // Object.keys(filter).forEach((key) =>
    //   filter[key] && key !== "searchBy"
    //     ? (variables[key] = filter[key].slice(0, 2))
    //     : false
    // );
    // console.debug(filter);
    //todo: 傳回Promise來判斷marker是否更新完成

    return new Promise((resolve) => {
      axiosAPI
        .post("graphql/", {
          query: print(queryEvents),
          variables: { ...filter, needHaspga },
        })
        .then((response) => {
          let tmp: Array<{
            No: number;
            DateUTC: Date;
            Latitude: number;
            Longitude: number;
            Depth: number;
            ML: number;
            hasPGA: boolean;
          }> = response.data.data.eventList;

          eventList.value = tmp.map(
            ({
              DateUTC,
              Latitude,
              Longitude,
              Depth,
              ML,
              hasPGA,
            }): eventType => ({
              date: DateUTC,
              lat: Latitude,
              lon: Longitude,
              depth: Depth,
              ml: ML,
              hasPGA: hasPGA,
            })
          );
          resolve(true);
          // console.debug(eventList);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  const resetState = () => {
    // eventList.value = {};
    Object.assign(eventList, ref<eventType>());
    console.debug("clean state");
  };
  return { getEventList, resetState, eventList };
});
